import React from "react"
import BackgroundDiv from "../shared/BackgroundDiv"
import { t } from "../../../i18n"
import Moment from "moment"
import CustomLink from "../shared/CustomLink"
import ImageCardLayout from "../shared/ImageCardLayout"

function selectGrandient(gradient) {
  switch (gradient) {
    case "hard":
      return "g-quiz--hard"
    case "med":
      return "g-quiz--medium"
    case "soft":
      return "g-quiz--soft"
    default:
      return ""
  }
}

const QuizzItem = props => {
  const {
    main_image: mainImage,
    name,
    description,
    gradient_type: gradientType,
    end_date: endDate,
    done,
    id
  } = props

  const normalizedEndDate = new Moment(endDate).format(t("date-format"))
  const hasBackground = !!mainImage.url

  const containerClass = [
    "g-quiz  vodafone-light mb-5 p-5 g-content-shadow",
    selectGrandient(gradientType),
    hasBackground ? "text-color " : "navbar-text "
  ].join(" ")

  const path = done ? `/quiz/history/${id}` : `quiz/${id}`

  return hasBackground ? (
    <div className="my-8 flex flex-col">
      <ImageCardLayout
        link={path}
        title={name}
        subtitle={description}
        image={mainImage.url}
        label="Quiz"
        enddate={endDate}
      />
    </div>
  ) : (
    <BackgroundDiv
      emptyBackground={!hasBackground}
      className={containerClass}
    >
      <div className="flex justify-between mb-1 above-content items-end">
        <p className="vodafone-bold title-size mb-1 g-quiz__title">{name}</p>
        <p className="mb-1 g-quiz__wrap">
          {done ? "Terminado a" : "Termina a"}{" "}
          <strong>{normalizedEndDate}</strong>
        </p>
      </div>
      <p className="g-quiz__description above-content flex-1">{description}</p>
      <CustomLink to={path} primary right className="above-content">
        {done ? "Rever respostas" : "Participar no Quiz"}
      </CustomLink>
    </BackgroundDiv>
  )
}

export default QuizzItem
